/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.create.details.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.calendar',
  'acme.common.service.helpers',
  'acme.common.service.rulesEngine',
  'acme.common.service.membership.offering',
  'acme.common.service.tenant',
  'acme.view.application.membership.offerings.create.details.modals.autorenew.controllers'
])

.controller('MembershipOfferingsCreateDetailsController', [
  '$state',
  '$scope',
  '$uibModal',
  '$timeout',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'RulesEngineService',
  'MembershipOfferingService',
  'TenantService',
  function(
    $state,
    $scope,
    $uibModal,
    $timeout,
    ApiService,
    CalendarService,
    HelpersService,
    RulesEngineService,
    MembershipOfferingService,
    TenantService
  ) {

    $scope.membershipOfferingsCreateDetails = {
      personTypes: [],
      autorenewalTypes: [
        { label: 'Off', value: 'none' },
        { label: 'Optional', value: 'optional' },
        { label: 'Required', value: 'required' },
      ],

      model: {
        name: '',
        subtitle: '',
        description: '',
        duration: 12,
        endTime: '',
        startTime: '',
        priceList: {},
        priceLists: [
          { prices: [] },
        ],
        benefits: [],
        rules: {},
        categoryInfo: {}
      },

      endTime: new Date(),
      startTime: new Date(),

      descriptionMax: 300,
      descriptionRemaining: 300,

      duration: {
        years: 1,
        months: 0
      },

      indefinite: false,
      isSubmitted: false,
      isLoaded: false,

      canDisableAutorenew: true,

      init: function() {
        this.getPersonTypes();

        if ($state.params.offeringId) {
          this.getOfferingPurchasedlist();
        }
        
        if($state.params.categoryId) {
          this.getCategory();
        }

        $scope.$on('MembershipOfferingsCreateController::Save', this.onMembershipOfferingsCreateControllerSave);
        $scope.$on('MembershipOfferingsCreateController::Update', this.onMembershipOfferingsCreateControllerUpdate);
      },

      getCategory: function() {
        ApiService.membership.categories.detail($state.params.categoryId).then(this.success.getCategory, this.error.getCategory);
      },

      getOfferingPurchasedlist: function() {
        var props = {
              levelId: $state.params.categoryId,
              offeringId: $state.params.offeringId,
              isDraftId: 'true'
            };

        ApiService.membership.categories.detail(props.levelId).then(function(response) {
          props.isDraftId = (response.data.payload.lastPublishedAt) ? 'true': 'false';
          ApiService.membership.offerings.summaries(props).then(function(res){
             if (res.data.payload.list.length) {
               $scope.membershipOfferingsCreateDetails.canDisableAutorenew = false;
             }
          });
        });
      },

      hasValidPrices: function () {
        var pricePoints = HelpersService.path(this.model, ['priceLists', 0, 'prices'], []);

        return this.isSubmitted && pricePoints.length > 0 && pricePoints.every(function (pricePoint) {
          return Number(pricePoint.price) >= 0;
        });
      },

      hasValidPricePoint: function () {
        return HelpersService.path(this.model, ['priceLists', 0, 'prices', 0, 'personType']) != null;
      },

      checkDescription: function() {
        if (this.model.description) {
          this.model.description = this.model.description.replace(/[\s\n]+/g,' ');
          var len = HelpersService.getTextLength(this.model.description);

          if (len > this.descriptionMax) {
            this.model.description = this.model.description.substr(0, this.descriptionMax);
          }
        }else{
          this.model.description = '';
        }

        this.descriptionRemaining = this.descriptionMax - HelpersService.getTextLength(this.model.description);
      },

      updateDuration: function() {
        this.model.duration = MembershipOfferingService.durationToMonths(this.duration);
        MembershipOfferingService.details.duration = MembershipOfferingService.durationToMonths(this.duration);
      },

      isValidDuration: function() {

        var r = true,
          duration = parseInt(this.model.duration, 10);

        if (this.isSubmitted) {
          r = (!isNaN(duration) && duration > 0);
        }

        return r;
      },

      durationError: function() {
        $scope.$emit('MembershipOffering::Error', {
          tab: 'details',
          message: 'Duration must be greater than 0.'
        });
      },

      /**
       * Backend returns an error when the person type is missing
       * and our model gets it from the selected price point.
       */
      pricePointError: function() {
        $scope.$emit('MembershipOffering::Error', {
          tab: 'details',
          message: 'Please select a price point.'
        });
      },

      pricesError: function() {
        $scope.$emit('MembershipOffering::Error', {
          tab: 'details',
          message: 'A price of at least $0 is required.'
        });
      },

      isIndividualAndFamily: function() {
        return this.model.categoryInfo.membershipLevelGroup === 'individualAndFamily';
      },

      isRecurringPaymentEnabled: function() {
        return TenantService.isRecurringPaymentEnabled();
      },

      runFrontendValidations: function () {
        var self = $scope.membershipOfferingsCreateDetails;

        if (!self.hasValidPricePoint()) {
          self.pricePointError();
          return false;
        }

        if (!self.hasValidPrices()) {
          self.pricesError();
          return false;
        }

        if (!self.isValidDuration()) {
          self.durationError();
          return false;
        }

        return true;
      },

      complete: function(flags) {
        this.model.startTime = CalendarService.toISO8601(this.startTime);
        this.model.endTime = (this.indefinite) ? null : CalendarService.toISO8601(this.endTime);
        this.model.duration = MembershipOfferingService.durationToMonths(this.duration);

        if (!this.runFrontendValidations()) {
          return;
        }

        if (flags) {
          var model = angular.extend({ categoryId: $state.params.categoryId }, this.model);

          if (flags.create) {
            ApiService.membership.offerings.create(model).then(this.success.create, this.error.create);
          } else if (flags.publish || flags.save) {
            ApiService.membership.offerings.update(model).then(this.success.update, this.error.update);
          }
        }
      },

      getPersonTypes: function() {
        var props = HelpersService.getPaginator({ sortField: 'displayOrder', sortDirection: 'asc' });
        props.types = 'membership';
        props.inactive = false;

        ApiService.price.types.list(props).then(this.success.getPersonTypes, this.error.getPersonTypes);
      },

      success: {

        init: function(response) {},

        generic: function(response) {
          $scope.$emit('MembershipOffering::Success', {
            tab: 'details',
            message: 'Successfully saved offering details'
          });
        },

        create: function(response) {
          $state.go('application.membership.offerings.edit', { categoryId: $state.params.categoryId, offeringId: response.data.payload.id });
        },

        update: function(response) {
          $scope.membershipOfferingsCreateDetails.success.generic(response);
        },

        getCategory: function(response) {
          var self = $scope.membershipOfferingsCreateDetails;
          self.model.categoryInfo = response.data.payload;

          /**
           * Defaults autorenewalType to 'none' if unset
           */
          if (self.model.autorenewalType == null) {
            self.model.autorenewalType = 'none';
          }
        },

        getPersonTypes: function(response) {
          $scope.membershipOfferingsCreateDetails.personTypes = response.data.payload.list;
        },
      },

      error: {

        init: function(response) {},

        generic: function(response) {
          $scope.$emit('MembershipOffering::Error', {
            tab: 'details',
            message: response.data.error
          });
        },

        create: function(response) {
          $scope.membershipOfferingsCreateDetails.error.generic(response);
        },

        update: function(response) {
          $scope.membershipOfferingsCreateDetails.error.generic(response);
        },

        getCategory: function(response) {
          $scope.membershipOfferingsCreateDetails.error.generic(response);
        },

        getPersonTypes: function(response) {
          $scope.membershipOfferingsCreateDetails.error.generic(response);
        },
      },

      onMembershipOfferingsCreateControllerSave: function(e, data) {
        var self = $scope.membershipOfferingsCreateDetails;

        self.isSubmitted = true;

        if (!self.runFrontendValidations()) {
          return;
        }

        $scope.membershipOfferingsCreateDetails.success.generic();
        MembershipOfferingService.details = angular.copy(self.model);
        MembershipOfferingService.ready.details = true;
      },

      onMembershipOfferingsCreateControllerUpdate: function(e, data) {
        var self = $scope.membershipOfferingsCreateDetails;

        angular.extend(self.model, data.offering);

        self.duration = MembershipOfferingService.monthsToDuration(self.model.duration);

        MembershipOfferingService.details = angular.copy(self.model);

        self.updateDuration();

        MembershipOfferingService.loaded.details = true;
      }
    };

    $scope.membershipOfferingsCreateDetails.init();

}])
.controller('MembershipOfferingsCreateDetailsDatePickerController', ['$scope', '$timeout', 'HelpersService', 'UserPreferencesService', function($scope, $timeout, HelpersService, UserPreferencesService) {
  $scope.membershipOfferingsCreateDetailsPicker = {

    isOpen: false,

    isPreferenceLoaded: false,

    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
    },

    init: function() {
      this.today();
      $scope.initDate = new Date('2016-15-20');
      $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'yyyyMMdd', 'shortDate'];
      $scope.format = $scope.formats[3];
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
        $scope.membershipOfferingsCreateDetailsPicker.isPreferenceLoaded = true;
      },0);
    },

    today: function() {
      this.dt = new Date();
    },

    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    },

    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.isOpen = true;
    },

    onDateFormatLoad: function (e, data) {
      var self = $scope.membershipOfferingsCreateDetailsPicker;
      self.dateFormat  = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    }

  };

  $scope.membershipOfferingsCreateDetailsPicker.init();

}]);